import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-50 h-10 w-10 rounded-full bg-primary-600 text-white shadow-lg hover:bg-primary-500 transition-all duration-200 flex items-center justify-center hover:scale-110"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};

export default BackToTop;
